import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#374151",
      d: "M16 2.002H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2ZM3 5.86c0-.473.448-.857 1-.857h12c.552 0 1 .384 1 .857v10.286c0 .474-.448.857-1 .857H4c-.552 0-1-.383-1-.857V5.86Z"
    }, null, -1)
  ]))]))
}
export default { render: render }